import { Box, Button, ButtonGroup } from "@mui/joy";
import {
  statsYearSelectorButtonOutlinedSx,
  statsYearSelectorButtonSelectedSx,
} from "../../styles/globalStyles";

type ExcursionYearSelectorProps = {
  years: number[];
  selectedYear: number | undefined;
  onYearChange: (year: number) => void;
};

export default function ExcursionYearSelector({
  years,
  selectedYear,
  onYearChange,
}: ExcursionYearSelectorProps) {
  return (
    <Box sx={{ mb: 2 }}>
      <ButtonGroup
        size="sm"
        sx={{
          flexWrap: "wrap",
          gap: 0.5,
          "--ButtonGroup-radius": "8px",
        }}
      >
        {years.map((year) => {
          const selected = selectedYear === year;

          return (
            <Button
              key={year}
              variant={selected ? "solid" : "outlined"}
              color="neutral"
              onClick={() => onYearChange(year)}
              sx={selected ? statsYearSelectorButtonSelectedSx : statsYearSelectorButtonOutlinedSx}
            >
              {year}
            </Button>
          );
        })}
      </ButtonGroup>
    </Box>
  );
}
